import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { createThunkErrorHandler } from '../../utils/handleThunkError.js';
import { handlePending } from '../../utils/handlePending.js';
import { signin, registration } from '../../http/usersAPI.js';

import {getSupport,sendSupportMessage} from '../../http/supportChatAPI.js'

export const handleLogin = createAsyncThunk(
    'user/handleLogin',
    async ({ login, password }, { rejectWithValue }) => {
        try {
            const data = await signin(login, password)
            return data
        } catch (e) {
            return rejectWithValue(e?.code || 'Login failed')
        }
    }
);

export const handleRegistration = createAsyncThunk(
    'user/handleRegistration',
    async ({ login, password, email, type, timezone, rules }, { rejectWithValue }) => {
        try {
            const data = await registration(login, password, email, type, timezone, rules)
            return data
        } catch (e) {
            return rejectWithValue(e?.code || 'Registration failed')
        }
    }
);

export const getSuuportChat = createAsyncThunk(
    'user/getSuuportChat',
    async function (params = {}, { rejectWithValue, dispatch, getState }) {

        dispatch(clearErrors())
        const state = getState().orders;
        const page = params.page ?? state.page;
        const limit = params.limit ?? state.limit;

        try {
            const data = await getSupport(page, limit)
            return data
        } catch (e) {
            return rejectWithValue(e?.code || 'Failed')
        }

    }
)

export const sendMessage = createAsyncThunk(
    'user/sendMessage',
    async function ({message}, { rejectWithValue, dispatch }) {

        dispatch(clearErrors())
        

        try {
            const data = await sendSupportMessage(message)
            dispatch(getSuuportChat())
            return data
        } catch (e) {
            return rejectWithValue(e?.code || 'Failed')
        }

    }
)





const userSlice = createSlice({
    name: 'user',
    initialState: {
        isAuth: false,
        token: null,
        errors: {},
        globalError: null,
        isLoading: false,
        user: {},
        user_info: {},
        support_chat: {
            isLoading: false,
            errors: {},
            data: [],
            count: 0,
            limit: 30,
            page: 1,
        }

    },
    reducers: {
        setUser(state, action) {
            state.isAuth = true
            state.user = action.payload.user
        },

        clearErrors: (state) => {
            state.errors = {}
            state.globalError = null
        },

        clearGlobalError: (state) => {
            state.globalError = null
        },

        removeUser(state) {
            state.isAuth = false
            state.user = {}
            localStorage.removeItem('token')
            state.isLoading = false
        },

        setUserBalance(state, action) {
            if (state.user) {
                state.user.balance = action.payload.balance
            }
        },

        setPageSupport(state, action) {
            const { page } = action.payload;
            state.support_chat.page = page;
        },

    },

    extraReducers: builder => {
        builder

            .addCase(handleLogin.rejected, createThunkErrorHandler("LOGIN"))
            .addCase(handleLogin.pending, handlePending)
            .addCase(handleLogin.fulfilled, (state, action) => {
                state.isLoading = false
                state.isAuth = true
                state.user = action.payload.user
                localStorage.setItem('token', action.payload.token)
            })

            .addCase(handleRegistration.rejected, createThunkErrorHandler("REGISTRATION"))
            .addCase(handleRegistration.pending, handlePending)
            .addCase(handleRegistration.fulfilled, (state, action) => {
                state.isLoading = false
                state.isAuth = true
                state.user = action.payload.user
                localStorage.setItem('token', action.payload.token)
            })

            .addCase(getSuuportChat.rejected, createThunkErrorHandler("SUPPORT"))
            .addCase(getSuuportChat.pending, handlePending)
            .addCase(getSuuportChat.fulfilled, (state, action) => {
                state.support_chat.isLoading = false
                state.support_chat.data = action.payload.data
                state.support_chat.count = action.payload.count
                state.support_chat.errors = {}
            })
            



    }
});

export const {
    setUser,
    clearErrors,
    clearGlobalError,
    removeUser,
    setUserBalance,
    setPageSupport
} = userSlice.actions;

export default userSlice.reducer;